import styled from 'styled-components';
// styled-components.
// -----------------------------------------------------------------------------
export const TabsRoot = styled.div `
  background-color: transparent;
`;
//# sourceMappingURL=Tabs.styles.js.map